import "react-app-polyfill/ie11";
import "core-js/stable";
import React, { useState, useCallback, useContext, useEffect, useRef } from "react";
import MainWebChat from "./components/MainWebchat";
import Header from "./components/Header";
import Footer from "./components/Footer";
import "./App.css";
import initCWASSO from "./util/initCWASSO";
import setCWACookies from "./util/setCWACookies";
import getCWACookies from "./util/getCWACookies";
import { createDirectLine } from "botframework-webchat";
import ErrorHandler from "./components/ErrorHandler";
import { getToken, getRefreshToken } from "./util/httprequest";
import { getAppInsights } from "./TelemetryService";
import TelemetryProvider from "./telemetry-provider";
import styleSet from "./util/chatBotCustomStyleSet";
import { AppContext } from "./util/appContext";
import { v4 as uuidv4 } from "uuid";
import { setCookie, getCookie, eraseCookie } from './util/cookieActions';
import aeroNonprodConfig from './configencrypted/aero_config.json';
import aeroProdConfig from './configencrypted/aero_prod_config.json';
import aeroNonprodConfig2 from './configencrypted/aero2_config.json';
import aeroProdConfig2 from './configencrypted/aero2_prod_config.json';
import decryptText from './util/decrypt';
import StaticLabels from "./util/staticLabels.json";
import liveAgentStaticLabels from "./util/liveAgentStaticLabels.json";

const BUTTON_TITLECASE_SELECTOR = [
  "button",
  "a.btn-primary",
  "a.btn-secondary",
  "a.viewMoreLink",
  "a.viewLineLink",
  ".extraButtons > a"
].join(",");

const toTitleCase = text =>
  text
    .toLowerCase()
    .replace(/\b([a-z])/g, match => match.toUpperCase());

const normalizeElementTextNodesToTitleCase = element => {
  if (!element) {
    return;
  }

  const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
  let textNode = walker.nextNode();

  while (textNode) {
    const rawValue = textNode.nodeValue;

    if (rawValue && rawValue.trim()) {
      textNode.nodeValue = toTitleCase(rawValue);
    }

    textNode = walker.nextNode();
  }
};

const applyTitleCaseToButtons = root => {
  const scope = root && root.querySelectorAll ? root : document;
  const elements = scope.querySelectorAll(BUTTON_TITLECASE_SELECTOR);

  elements.forEach(normalizeElementTextNodesToTitleCase);
};
//Main entry component for connecting to Bot.
export default () => {
  // let appInsights = null;
  const [isMaximised, setMaximizeflag] = useState(false);
  const [directLine, setDirectLine] = useState();
  const [store, setStore] = useState();
  const [isLiveAgent, setLiveAgent] = useState(false);
  const [showSpinner, setSpinner] = useState(true);
  const [isOpenModal, showModal] = useState(false);
  const [isSurveyOpen, showSurvey] = useState(false);
  const [errorOccured, showErrorPage] = useState({
    isErrorOccured: false,
    message: ""
  });
  // const [refresh, setRefresh] = useState(false);
  const headerRef = useRef();
  const [userLanguage, setUserLanguage] = useState("");
  const [appInsights, setAppInsights] = useState(null);
  const [isSurveySubmitted, setSurveyFlag] = useState(false);
  const [headerIconsDisplay, setHeaderIconsDisplay] = useState(true);
  const [showTimerBox, setShowTimerBox] = useState(false);
  const [callbackFormUrl, setCallbackFormUrl] = useState("");
  const [surveyLink, setSurveyLink] = useState("");
  const [satmatrixSurvey, setSatmatrixSurvey] = useState(false);
  const [satmatrixSurveyIFrame, setSatmatrixSurveyIFrame] = useState(false);
  const [isAgentInitiated, setAgentInitiated] = useState(false);
  const [isDisplay, setIsDisplay] = useState(false);
  const [receiverOrigin, setreceiverOrigin] = useState('*');
  const [cookieSetData, setCookieSetData] = useState(false);
  let proactiveBot = false;
  const context = useContext(AppContext);
  const surveyPageShow = useRef(false);
  const [localMaximized, setLocalMaximized] = useState(isMaximised);

  useEffect(() => {
    let rafId = null;

    const scheduleNormalize = () => {
      if (rafId !== null) {
        return;
      }

      rafId = window.requestAnimationFrame(() => {
        applyTitleCaseToButtons(document);
        rafId = null;
      });
    };

    applyTitleCaseToButtons(document);

    const observer = new MutationObserver(scheduleNormalize);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });

    return () => {
      observer.disconnect();

      if (rafId !== null) {
        window.cancelAnimationFrame(rafId);
      }
    };
  }, []);

  const resizeWindowScreen_Latest=()=>{
    const rootMax = document.querySelector('.root-max');
    // Get window width
    if(rootMax){
    document.getElementById("root").removeAttribute("style");
    const windowWidth = window.screen.width;
    console.log(windowWidth,"..windowWidth");
    if(window.config.isAccessibilityFeature){
    document.getElementById("root").classList.remove("adjustResize");
    }
    if(window.config.isAdjustable){
    if(getCookie(window.config.businessUnit + '-adjustResize')){
      if(window.config.isAccessibilityFeature){
      document.getElementById("root").classList.add("adjustResize");
      }
      if (windowWidth >= 1601) {
        rootMax.style.width = '800px';
        rootMax.style.height = '750px';
      } else if (windowWidth <= 1600) {
        rootMax.style.width = '700px';
        rootMax.style.height ='525px';
      }
    }
    else{
      if (windowWidth >= 1601) {
        rootMax.style.width = '425px';
        rootMax.style.height = '600px';
      } else if (windowWidth <= 1600) {
        rootMax.style.width = '375px';
        rootMax.style.height ='500px';
      }
    }
    }
    else{
      if (windowWidth >= 1601) {
        rootMax.style.width = '425px';
        rootMax.style.height = '600px';
      } else if (windowWidth <= 1600) {
        rootMax.style.width = '375px';
        rootMax.style.height ='500px';
      }
    }
    // Apply styles based on window width
    
    }
    else{
    window.parent.postMessage({key:'minimise', launcherIcon: false}, window.config.pageOrigin);
    }
  }
  document.addEventListener("DOMContentLoaded", function () {
    console.log("111");
    //applyStyles();
  });
  document.addEventListener("beforeunload", function () {
    sessionStorage.removeItem("cwaSSOToken");
  });

  window.addEventListener("load", event => {
    sessionStorage.setItem('notification', false);
    sessionStorage.setItem('proactiveInactivity', Date.now());
    sessionStorage.removeItem("chatbotActive");
    if (event.origin !== window.config.pageOrigin)
      return;
  });

  useEffect(() => {
    document.addEventListener("marketoformsubmit", event => {
      store.dispatch({
        type: "WEB_CHAT/SEND_POST_BACK",
        payload: {
          value: {
            processName: "marketoFormSubmitted"
          }
        }
      });
    });

    let browserName = (function (agent) {
      switch (true) {
        case agent.indexOf("edge") > -1: return "Edge";
        case agent.indexOf("edg/") > -1: return "Edge";
        case agent.indexOf("opr") > -1 && !!window.opr: return "Opera";
        case agent.indexOf("chrome") > -1 && !!window.chrome: return "Chrome";
        case agent.indexOf("trident") > -1: return "IE";
        case agent.indexOf("firefox") > -1: return "Firefox";
        case agent.indexOf("safari") > -1: return "Safari";
        default: return "other";
      }
    })(window.navigator.userAgent.toLowerCase());
    const callBotClick = (headerRef) => {
      const proactiveInactivity = sessionStorage.getItem("proactiveInactivity");

      if (proactiveInactivity) {
        const savedTime = Number(proactiveInactivity); // Convert the stored timestamp to a number
        const currentTime = Date.now();
        const timeElapsed = currentTime - savedTime;

        // Set a 20-second delay condition
        const proactiveDelay = window.config.subscriptionDelay; // 20 seconds
        const remainingTime = proactiveDelay - timeElapsed;

        if (remainingTime <= 0) {
          // 20 seconds have passed, trigger botIconClick immediately
          if (headerRef.current) {
            headerRef.current.botIconClick();
          }
        } else {
          // Wait for the remaining time and then trigger botIconClick
          setTimeout(() => {
            if (headerRef.current) {
              headerRef.current.botIconClick();
            }
          }, remainingTime);
        }
      } else {
        // Fallback if proactiveInactivity isn't set (rare case)
        const currentTime = Date.now();
        sessionStorage.setItem("proactiveInactivity", currentTime); // Save current time
        setTimeout(() => {
          if (headerRef.current) {
            headerRef.current.botIconClick();
          }
        }, window.config.subscriptionDelay);
      }
    }
    window.parent.postMessage({ key: 'init_cwa_sso', origin: window.location.origin }, receiverOrigin);
    window.onmessage = async (e) => {
      const data = JSON.parse(JSON.stringify(e.data));

      switch (data.key) {
        case 'init_cwa_sso':
          localStorage.setItem("pageUrl", data.pageUrl);

          let SBG = '';
          let isFAQ2_0 = false;
          let showGenAIResponse = false;
          let localConfig = '';
          let isAEM = false;
          let isChina = false;
          let autoOpen = false;
          switch (data.value) {
            case 'https://stage.honeywellaerospace.com':
            case 'https://dpublish-aerospacebt.aws.aem.honeywell.com':
            case 'https://qpublish-aerospacebt.aws.aem.honeywell.com':
            case 'https://stageaeroservices.honeywellaerospace.com':
            case 'https://stageaerocontracts.honeywellaerospace.com':
            case 'https://stageaerotechpubs.reactapp.honeywellaerospace.com':
            case 'https://stagemspreporting.honeywellaerospace.com':
              SBG = 'AERO';
              localConfig = aeroNonprodConfig;
              break;
            case 'https://www.honeywellaerospace.com':
            case 'https://aeroservices.honeywellaerospace.com':
            case 'https://contracts.aerospace.honeywellaerospace.com':
            case 'https://contracts.honeywellaerospace.com':
            case 'https://aerotechpubs.honeywellaerospace.com':
            case 'https://techpubs.honeywellaerospace.com':
            case 'https://mspreporting.honeywellaerospace.com':
              SBG = 'AERO';
              localConfig = aeroProdConfig;
              break;
            case 'https://qaerospace2.honeywell.com':
              SBG = 'AERO';
              localConfig = aeroNonprodConfig2;
              break;
            case 'https://aerospace2.honeywell.com':
              SBG = 'AERO';
              localConfig = aeroProdConfig2;
              break;
            default:
              SBG = '';
              break;
          }

          if (SBG=='AERO') {
            let decrypted = await decryptText(localConfig.encrypted);
            window.config = JSON.parse(decrypted);
            window.config.autoOpen=autoOpen;
            window.config.isFAQ2 = isFAQ2_0 //for running faq2.0 ui with different app service abckend.
            window.config.showGenAIResponse = showGenAIResponse
          } else {
            const response = await fetch(`${window.location.origin}/config.json?SBG=${SBG}`, {
              'headers': {
                "Origin": data.value,
              }
            });
            window.config = await response.json();
          }

          window.config.isAEM = isAEM;
          window.config.isChina = isChina;
          window.config.isDev = isFAQ2_0;

          if (window.config.isNewSSO) {
            window.config.isNewSSO = window.config.isNewSSO //for Adm and UOP non aem pages should use old authentication.
          }
          window.config.showTypingIndicator = true;
          window.config.isDefaultWorkflowClicked = false;
          window.config.elementsCount = 0;
          
          // window.config.dp = data.dp;
          window.config.language = "en";
          window.config.countrySelectedOnPortal = "us"; //make it us later
          setCWACookies('cwaSSOToken', "Anonymous", 100000); //uncomment it later
          //setCWACookies('cwaSSOToken', "ewogICJ0eXAiIDogIkpXVCIsCiAgImFsZyIgOiAiUlMyNTYiCn0.ewogICJkb21haW4iIDogInkxaGxiZTJlOHpwMTEiLAogICJhcHBJZCIgOiAieTFobGJlMmU4enAxIiwKICAiaXNzIiA6ICJzdGFnZS5ob25leXdlbGxhZXJvc3BhY2UuY29tIiwKICAianRpIiA6ICIyNzAyOGMzZi02ODMyLTQ5OTctOWQwNi1kMzRkNzU5Y2IwMzkiLAogICJzdWIiIDogImFmZDA4YmJmLWRjMDAtNDE4MC04ZTU1LTA3YzZkZGI1MGMwYiIsCiAgImlhdCIgOiAxNzgxNzI4NDA5LAogICJleHAiIDogMTc4MTczMDIwOQp9.oJrNQBQ0p7eUFOD-nBVhaReQ2DDJWReBDP3xoqghGnlCinORHj-lz1zOSoYuOzDc7ZukFWq94E4U5oKnhmVVzSwrh07T3PatzjktC0KVjPm2PJ-1OvIbrp5g7l2D_MLGqnQZVhi93uHLqzQCcX0D_gI1b4FXtU3IrO7UPDWc1dYFKzLtsoKGJttSBqU02C3JN2tta1E8-1Ln_-7R02a_Ynrbmhov5f0ArxP-pJYjIsgU5EoIpuSEfuvEtIxOtHFLwLu3F2BfqgoM2L3RX64eI6lI7uD5oHFSshtrc_sNXWLFSRqqMnjPcJHb1iSaJJRp7qaIgBcGohZbbT_z-FPJRw", 100000);
          window.config.portalPageUrl = data.pageUrl;
          window.config.sessionRefreshed = data.sessionRefreshed;
          window.config.pageOrigin = data.value;
          window.config.browserName = browserName;
          setIsDisplay(true);
          if(window.config.isNewSSO) {
            window.parent.postMessage({ key: 'display_chatbot', businessUnit:window.config.businessUnit,cookieUrl:window.config.cookieUrl,cookieKey:window.config["3469726563746c696e650k08"].split("&=")[1],jwtTokenName:window.config.isChina ? window.config.jwtTokenNameHybris:window.config.jwtTokenName,pageOrigin:window.config.pageOrigin,cardpageOrigin:"*" }, window.config.pageOrigin);
            window.parent.postMessage({ key: 'chat_bot_loaded', businessUnit:window.config.businessUnit,cookieUrl:window.config.cookieUrl,cookieKey:window.config["3469726563746c696e650k08"].split("&=")[1],jwtTokenName:window.config.isChina ? window.config.jwtTokenNameHybris:window.config.jwtTokenName,pageOrigin:window.config.pageOrigin,cardpageOrigin:"*",migratedPages:window.config.nextMigratedPages }, window.config.pageOrigin);
          }
          break;
        case 'cwa_sso_token_set':
          if (!data.value) {
            data.value = 'Anonymous';
          }
          setCWACookies('cwaSSOToken', data.value, 100000);
          window.config.pageTitle = data.pageTitle;
          window.config.language = data.pageLanguage;
          window.config.countrySelectedOnPortal = data.countrySelectedOnPortal;
          window.config.portalPageUrl = data.pageUrl;
          window.config.sessionRefreshed = data.sessionRefreshed;
          break;
        case 'cwa_cookies_http':
           if(!window.config.removedCookie && getCookie(`${window.config.businessUnit}-AuthToken`) && getCookie(`${window.config.businessUnit}-AuthToken`) != data.value){
           window.config.removedCookie=true;
           removeDLCookies("sessiontimeout");
          }
          setCWACookies('cwaSSOToken', data.value, 100000);
          setCookie(`${window.config.businessUnit}-AuthToken`, data.value);
          window.config.estimatedWaitTime = null;
          window.config.pageTitle = data.pageTitle;
          if (window.config.businessUnit == "AERO-GCEGBT") {
            window.config.language = "en";
            window.config.countrySelectedOnPortal = "us";
            data.countrySelectedOnPortal ="us";
          }
          else if(window.config.isChina){
            window.config.countrySelectedOnPortal = "CN";
            data.countrySelectedOnPortal ="CN";
            window.config.language = data.pageLanguage ? data.pageLanguage : "en";
          }
          else {
            window.config.language = data.pageLanguage ? data.pageLanguage : "en";
          }
          window.config.countrySelectedOnPortal = data.countrySelectedOnPortal ? data.countrySelectedOnPortal : "us";
          window.config.portalPageUrl = data.pageUrl;
          window.config.sessionRefreshed = data.sessionRefreshed;
          window.config.b2bunit = data.b2bunit;
          window.config.dp = data.dp;
          window.config.redirectIndicator = data.dataRedirect;
          context.setPageTitleCookie(data.pageTitle);
          context.setPageLanguage(data.pageLanguage);
          context.setCountrySelectedOnPortal(data.countrySelectedOnPortal);
          if (window.config.redirectIndicator && window.config.redirectIndicator.includes("PartnerPortal") && !proactiveBot) {
            proactiveBot = true;
            console.log("hi I came to redirectIndicator", proactiveBot);
            const businessUnit = window.config.businessUnit;
            const isAuthenticated = getCookie(`${businessUnit}-Token`) &&
              getCookie(`${businessUnit}-Conversation`) &&
              getCookie(`${businessUnit}-AuthToken`) &&
              getCWACookies('cwaSSOToken') &&
              getCookie(`${businessUnit}-AuthToken`).length === getCWACookies('cwaSSOToken').length &&
              getCookie(`${businessUnit}-Language`) &&
              getCookie(`${businessUnit}-Language`) === window.config.language;
            if (!isAuthenticated) {
              if (headerRef.current) {
                callBotClick(headerRef);
              }
            }
          }
          break;
        case 'open_chatbot':
          if (headerRef.current) {
            headerRef.current.botIconClick();
          }
          break;
        default:
          break;
      }
    };
    sessionStorage.removeItem(window.config.businessUnit + '-SatmatrixSurveyOpen');
    const interval = setInterval(() => {
      if (getCookie(window.config.businessUnit + '-BotLastResponseTime') && document.getElementById("root").classList.contains("root-max")) {
        const botLastResponseTime = new Date(getCookie(window.config.businessUnit + '-BotLastResponseTime'));
        const currentTime = new Date();
        const diff = Math.abs(currentTime.getTime() - botLastResponseTime.getTime()) / 60000;
        const diffCheck = window.config.sessionIdle? window.config.sessionIdle:15;
        if (diff > diffCheck) {
          showModal(true);
          // if(window.config.isAttachment){
          // const ATTACHMENTS_KEY = window.config.businessUnit+'_dca_persisted_attachments';
          // sessionStorage.removeItem(ATTACHMENTS_KEY);
          // }
          context.setModalProps({ refresh: false, close: false, quitAgentQueue: false, busyNotification: true });
          if (window.config.isNewPrivacy) {
            eraseCookie(window.config.businessUnit + '-isPrivacyAccepted');
          }
          removeDLCookies("sessiontimeout");
        }
      }
    }, 10 * 1000);
    return () => { clearInterval(interval); };
  }, []);

  const accessToken = getCWACookies("cwaSSOToken");

  function setDirectLineToken() {
    const isPrivacyAccepted = getCookie(window.config.businessUnit + '-isPrivacyAccepted');
    if (!window.config.isNewPrivacy || isPrivacyAccepted) {
      setDirectLineTokenCall();
    }
  }
  function capitalizeFirstLetter(string){
    return string
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };
  function formatWaitTime(valueInMinutes,hoursText,hourText,minutesText,minuteText) {
    if (valueInMinutes >= 60) {
        const hours = Math.floor(valueInMinutes / 60);
        const minutes = valueInMinutes % 60;
        // return hours > 1 
        //     ? `${hours} ${hoursText}  ${minutes} ${minutesText}` 
        //     : `${hours} ${hourText} ${minutes} ${minuteText}`;
      return hours > 1
        ? `${hours} ${hoursText} ${(minutes > 1 ? minutesText : minuteText)}`
        : `${hours} ${hourText} ${(minutes > 1 ? minutesText : minuteText)}`;
    } else {
        return `${valueInMinutes} ${(valueInMinutes > 1 ? minutesText : minuteText)}`;
    }
}
  function AMPMFormat(date) {
  var hours = date.getHours();
  // var minutes = date.getMinutes();
  var ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  // minutes = minutes < 10 ? '0'+minutes : minutes;
  // var strTime = hours + ':' + minutes + ' ' + ampm;
  return { hour: hours, ampm: ampm };
}
  function GreetUser(userLanguage) {
  const timeFormat = AMPMFormat(new Date());
  if (timeFormat.ampm === "AM") {
    // if(timeFormat.hour >=5 && timeFormat.hour <= 11){
    //   return "Good morning!"
    // }else{
    //   return "Good morning!"
    // }
    return userLanguage
      ? capitalizeFirstLetter(StaticLabels[userLanguage.toLowerCase()].GoodMorning)
      : capitalizeFirstLetter("good morning");
  } else {
    if (timeFormat.hour >= 4 && timeFormat.hour <= 7) {
      return userLanguage
        ? capitalizeFirstLetter(StaticLabels[userLanguage.toLowerCase()].GoodEvening)
        : capitalizeFirstLetter("good evening");
    }
    if (timeFormat.hour >= 1 && timeFormat.hour <= 4) {
      return userLanguage
        ? capitalizeFirstLetter(StaticLabels[userLanguage.toLowerCase()].GoodAfternoon)
        : capitalizeFirstLetter("good afternoon");
    }

    if (timeFormat.hour === 12) {
      return userLanguage
        ? capitalizeFirstLetter(StaticLabels[userLanguage.toLowerCase()].GoodAfternoon)
        : capitalizeFirstLetter("good afternoon");
    }

    if (timeFormat.hour > 7 && timeFormat.hour) {
      return userLanguage
        ? capitalizeFirstLetter(StaticLabels[userLanguage.toLowerCase()].GoodEvening)
        : capitalizeFirstLetter("good evening");
    }
  }
}
  function setDirectLineTokenCall() {
    const businessUnit = window.config.businessUnit;
    const isAuthenticated = getCookie(`${businessUnit}-Token`) && 
                            getCookie(`${businessUnit}-Conversation`) &&
                            getCookie(`${businessUnit}-AuthToken`) && 
                            getCWACookies('cwaSSOToken') &&
                            getCookie(`${businessUnit}-AuthToken`).length === getCWACookies('cwaSSOToken').length &&
                            getCookie(`${businessUnit}-Language`) && 
                            getCookie(`${businessUnit}-Language`) === window.config.language;
   
    if (isAuthenticated) {
        const token = getCookie(`${businessUnit}-Token`);
        setDirectLine(createDirectLine({ token }));
        if (window.config.isPersisted) {
            setCookie(`${businessUnit}-OldCoversation`, true);
            setCookie(`${businessUnit}-botMaximiseTime`, Date.now());
        }
    } else {
        removeDLCookies(false);
        if(!cookieSetData){
          window.parent.postMessage({ key: 'chat_bot_loaded', businessUnit:window.config.businessUnit,cookieUrl:window.config.cookieUrl,cookieKey:window.config["3469726563746c696e650k08"].split("&=")[1],jwtTokenName:window.config.isChina ? window.config.jwtTokenNameHybris:window.config.jwtTokenName,pageOrigin:window.config.pageOrigin,cardpageOrigin:"*",migratedPages:window.config.nextMigratedPages }, window.config.pageOrigin);
          setCookieSetData(true);  
        }
        getDirectLineToken()
            .then((result) => {
                const token = result.token;
                setDirectLine(createDirectLine({ token }));

                if (window.config.isPersisted) {
                    setCookie(`${businessUnit}-Token`, token);
                    setCookie(`${businessUnit}-AuthToken`, getCWACookies('cwaSSOToken'));
                    setCookie(`${businessUnit}-OldCoversation`, false);
                    setCookie(`${businessUnit}-Language`, window.config.language);
                }
            })
            .catch((error) => {
                if (appInsights) {
                    appInsights.trackTrace({
                        message: 'Exceptions',
                        properties: {
                            name: 'Direct line error',
                            message: error.message,
                            stack: error.stack
                        }
                    });
                }
            });
    }
    refreshDLToken();
  }
  const removeDLCookies = (timeout) => {
    eraseCookie(window.config.businessUnit + '-Token');
    eraseCookie(window.config.businessUnit + '-Conversation');
    eraseCookie(window.config.businessUnit + '-botMaximise');
    eraseCookie(window.config.businessUnit + '-AuthToken');
    eraseCookie(window.config.businessUnit + '-OldCoversation');
    eraseCookie(window.config.businessUnit + '-Language');
    eraseCookie(window.config.businessUnit + '-EnableSendBox');
    eraseCookie(window.config.businessUnit + '-BotLastResponseTime');
    eraseCookie(window.config.businessUnit + '-botMaximiseTime');
    eraseCookie(window.config.businessUnit + '-CheckOrderLob');
    eraseCookie(window.config.businessUnit + '-CheckOriginalId');
    eraseCookie(window.config.businessUnit + '-WebPopup');
    if(window.config.isAttachment){
    const ATTACHMENTS_KEY = window.config.businessUnit+'_dca_persisted_attachments';
    sessionStorage.removeItem(ATTACHMENTS_KEY);
      }
    if (timeout && timeout == "sessiontimeout") {
     
      if (getCookie(window.config.businessUnit + '-adjustResize') && window.config.isAdjustable == true) {
        eraseCookie(window.config.businessUnit + '-adjustResize');
      }
    }
  };

  const refreshDLToken = () => {
    setInterval(() => {
      if (getCookie(window.config.businessUnit + '-Token')) {
        getRefreshDirectLineToken();
      }
    }, 20 * 60 * 1000);
  };

  const handleSpinnerChange = useCallback(() => {
    setSpinner(!showSpinner);
  }, [showSpinner, setSpinner]);

  const handleSurveyCardChange = useCallback(
    event => {
      
      if (isSurveyOpen) {
        setSurveyFlag(!isSurveySubmitted);
        // setDirectLine(null);
        // setStore(null);
        context.setLiveAgent(false);
      }
      showSurvey(!isSurveyOpen);
    },
    [
      isSurveySubmitted,
      isSurveyOpen,
      setSurveyFlag,
      showSurvey,
      // setDirectLine,
      // setStore
      setLiveAgent
    ]
  );

  const handleRefreshModalPopup = useCallback(event => {
    if (isSurveyOpen) {
      showSurvey(false);
    }
    showModal(false);
    showErrorPage({ isErrorOccured: false, message: "" });
    setSpinner(true);
    context.setLiveAgent(false);
    setAgentInitiated(false);
    context.setShowSendBox(false);
    context.setDisableSendBox(true);
    context.setEnableSendBoxAERO(false);
    setShowTimerBox(false);
    context.setShowHeaderFooter(false);
    context.setEnableScroll(false);
    setUserLanguage("");
    context.setOptionSelected(false);
    context.setHideStickyMenu(false);
    context.setModalProps({ refresh: false, close: false, quitAgentQueue: false, busyNotification: false });
  },
    [setDirectLineToken, setUserLanguage, setShowTimerBox, setAgentInitiated, setLiveAgent]
  );

  const closeLiveAgentProps = () => {
    setShowTimerBox(false);
    context.setModalProps({ refresh: false, close: false, quitAgentQueue: false, busyNotification: false });
    context.setUsersCount(0);
  }
  const handleMaximizeChange = useCallback(() => {
    if (!directLine) {
      // We will load DirectLineJS asynchronously on first render.
      setDirectLineToken();
    }
    if (!isMaximised) {
      sessionStorage.setItem("chatbotActive", true);
      sessionStorage.setItem('notification', true);

      if (context.showHeaderFooter !== true) {
        context.setShowHeaderFooter(false);
        context.setShowSendBox(false);
      }

      //On Survey submit we are refreshing the bot conversation.
      if (isSurveySubmitted) {
        handleSpinnerChange();
        setSurveyFlag(!isSurveySubmitted);
        removeDLCookies(false);
        setDirectLine(null);
        setStore(null);
        setDirectLineToken();
        setHeaderIconsDisplay(true);
        setUserLanguage("");
        closeLiveAgentProps();
        context.setDisableSendBox(true);
        context.setEnableSendBoxAERO(false);
      }
      document.getElementById("root").classList.add("root-max");
      document.getElementById("root").classList.remove("root-min");
      document.getElementById("main").classList.remove("main-min");
      document.getElementById("main").classList.add("main-max");
      resizeWindowScreen_Latest();
      context.setMenuOpen(false);
      window.parent.postMessage({ key: 'maximise', isAdjustable: window.config.isAdjustable, adjustResize: getCookie(window.config.businessUnit + '-adjustResize') }, window.config.pageOrigin);
      setTimeout(() => {
        if (document.getElementById("web-chat") && !isMaximised && !document.querySelector('.homeContainer')) {
          document.getElementById("web-chat").scrollTop = document.getElementById("web-chat").scrollHeight;
        }
      }, 0);
    } else {
      // context.setShowHeaderFooter(false);
      // context.setEnableScroll(false);
      context.setMenuOpen(false);
      sessionStorage.setItem('notification', false);
      sessionStorage.removeItem("chatbotActive");
      document.getElementById("root").removeAttribute("style");
      document.getElementById("root").classList.remove("root-max");
      document.getElementById("main").classList.remove("main-max");
      document.getElementById("main").classList.add("main-min");
      window.parent.postMessage({ key: 'minimise', launcherIcon: false }, window.config.pageOrigin);
    }

    setMaximizeflag(!isMaximised);
    if (window.config.isPersisted) {
      setCookie(window.config.businessUnit + '-botMaximise', !isMaximised);
    }
  }, [
    isMaximised,
    showSpinner,
    isSurveySubmitted,
    setMaximizeflag,
    handleSpinnerChange,
    setSurveyFlag,
    closeLiveAgentProps
  ]);
  const handleCloseModalPopup = useCallback(event => {
    setSurveyFlag(!isSurveySubmitted);
    setHeaderIconsDisplay(false);
    context.setLiveAgent(false);
    context.setOptionSelected(false);
    context.setShowGoBackbutton(true);
    context.setHideStickyMenu(false);
    context.setShowHeaderFooter(false);
    context.setEnableScroll(false);
    sessionStorage.removeItem("chatbotActive");
    sessionStorage.setItem('notification', false);
    context.setModalProps({ refresh: false, close: false, quitAgentQueue: false, busyNotification: false });
    showModal(false);
    context.setIsAccountChanged(false);
    removeDLCookies(false);
  }, [handleMaximizeChange, setSurveyFlag]);

  const handleCloseBotInTabs = useCallback(() => {
    context.setMenuOpen(false);
    sessionStorage.setItem('notification', false);
    sessionStorage.removeItem("chatbotActive");
    document.getElementById("root").removeAttribute("style");
    document.getElementById("root").classList.remove("root-max");
    document.getElementById("main").classList.remove("main-max");
    document.getElementById("main").classList.add("main-min");
    window.parent.postMessage({ key: 'minimise', launcherIcon: false }, window.config.pageOrigin);
    setMaximizeflag(false);
    window.history.go(0);
  }, [
    isMaximised,
    isSurveySubmitted
  ]);

  const handleModalChange = useCallback(
    actionItem => event => {
      context.setMenuOpen(false);
      window.config.hideTextBox=false;
      // sendMessage("GetSurveyLink");
      if (actionItem.target === "refresh") {
        if (actionItem.backMenu) {
          context.setMenuOpen(true);
        }
        if (actionItem.value) {
          if (actionItem.value === "Yes") {
            if (isSurveyOpen) {
              showSurvey(false);
            }
            removeDLCookies(false);
            setDirectLine(null);
            setStore(null);
            showErrorPage({ isErrorOccured: false, message: "" });
            setSpinner(true);
            context.setLiveAgent(false);
            context.setChatLeftStart(false);
            setAgentInitiated(false);
            context.setShowSendBox(false);
            context.setDisableSendBox(true);
            context.setEnableSendBoxAERO(false);
            setShowTimerBox(false);
            context.setShowHeaderFooter(false);
            context.setEnableScroll(false);
            setDirectLineToken();
            setUserLanguage("");
            context.setOptionSelected(false);
            context.setHideStickyMenu(false);
          }
          context.setModalProps({ refresh: false, close: false, quitAgentQueue: false, busyNotification: false });
        } else {
          context.setModalProps({ refresh: true, close: false, quitAgentQueue: false, busyNotification: false });
        }
      }

      if (actionItem.target === "closeWithSurvey") {
        handleSurveyCardChange();
        setHeaderIconsDisplay(false);
        context.setShowHeaderFooter(false);
        context.setEnableScroll(false);
      }

      if (actionItem.target === "close") {
        // const ATTACHMENTS_KEY = window.config.businessUnit+'_dca_persisted_attachments';
        // sessionStorage.removeItem(ATTACHMENTS_KEY);
        if (actionItem.value) {
          if (store != null) {
            store.dispatch({
              type: "WEB_CHAT/SEND_EVENT",
              payload: {
                name: "feedbackCancelButton"
              }
            });
          }
          context.setModalProps({ refresh: false, close: false, quitAgentQueue: false, busyNotification: false });
        }
        else {
          context.setModalProps({ refresh: false, close: true, quitAgentQueue: false, busyNotification: false });
        }
      }

      if (actionItem.target === "closeLaunchIcon") {
        // const ATTACHMENTS_KEY = window.config.businessUnit+'_dca_persisted_attachments';
        // sessionStorage.removeItem(ATTACHMENTS_KEY); 
        handleMaximizeChange();
        handleCloseModalPopup();
      }

      if (actionItem.target === "QuitandCreateTicket") {
        // if (actionItem.value) {
        //   if (actionItem.value === "Yes") {
        cancelSession();
        handleSurveyCardChange();
        window.open(callbackFormUrl, "_blank");
        //   } else {
        //     context.setModalProps({ refresh: false, close: false, quitAgentQueue: false, busyNotification: false });
        //   }
        // } else {
        //   context.setModalProps({ refresh: false, close: false, quitAgentQueue: false, busyNotification: true });
        // }
      }

      if (actionItem.target === "QuitAgentQueue") {
        // if (actionItem.value) {
        //   if (actionItem.value === "Yes") {
        cancelSession();
        handleSurveyCardChange();
        setHeaderIconsDisplay(false);
        context.setShowHeaderFooter(false);
        context.setShowGoBackbutton(false);
        context.setEnableScroll(false);
        window.open(callbackFormUrl, "_blank");
        //   } else {
        //     context.setModalProps({ refresh: false, close: false, quitAgentQueue: false, busyNotification: false });
        //   }
        // } else {
        //   context.setModalProps({ refresh: false, close: false, quitAgentQueue: true, busyNotification: false });
        // }
      }

      if (actionItem.target === "shutdown") {
        // const ATTACHMENTS_KEY = window.config.businessUnit+'_dca_persisted_attachments';
        // sessionStorage.removeItem(ATTACHMENTS_KEY);
        setSurveyLink("");
        setSatmatrixSurvey(false);
        setSatmatrixSurveyIFrame(false);
        handleSurveyCardChange();
        handleMaximizeChange();
        context.setLiveAgent(false);
        context.setShowHeaderFooter(false);
        sessionStorage.removeItem("chatbotActive");
        sessionStorage.removeItem(window.config.businessUnit + '-SatmatrixSurveyOpen');
        window.history.go(0);
      } else {
        showModal(isMaximised && actionItem.isOpenModal);
      }
    },
    [isMaximised, isSurveyOpen, showModal, showSurvey, handleSurveyCardChange, callbackFormUrl, setSurveyLink, setSatmatrixSurvey, setSatmatrixSurveyIFrame, setLiveAgent]
  );


  // async function openInNewTab(href){
  //   const anchorDoc=Object.assign(document.createElement('a'),{});
  //   return anchorDoc;
  // }
  async function cancelSession() {
    // const agentSessionId = sessionStorage.getItem("AgentSessionID");
    // if (agentSessionId != null) {
    //   const response = await getAgentToken(agentSessionId);
    //   return response;
    // }
    // if(window.config.isAttachment){
    //       const ATTACHMENTS_KEY = window.config.businessUnit+'_dca_persisted_attachments';
    //       sessionStorage.removeItem(ATTACHMENTS_KEY); 
    //       }
    if (isAgentInitiated) {
      if (store != null) {
        store.dispatch({
          type: "WEB_CHAT/SEND_EVENT",
          payload: {
            name: "CancelSession"
          }
        });
      }
    }
  }
  const isMobileDevice = () => {
  const userAgent = navigator.userAgent;
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
  };
  async function getDirectLineToken() {
    const res = await getToken();
    return (res.data && res.data.token) ? res.data : null;
  }

  async function getRefreshDirectLineToken() {
    const res = await getRefreshToken();
    if (res.data && res.data.token) {
      setCookie(window.config.businessUnit + '-Token', res.data.token);
    }
    else {
      removeDLCookies(false);
    }
  }

  let isRejectedActivity = false;
  if (!store) {
    setStore(
      window.WebChat.createStore({}, ({ dispatch }) => next => async action => {
        setTimeout(() => {
          if (document.getElementById("web-chat") && !document.querySelector('.homeContainer')) {
            document.getElementById("web-chat").scrollTop = document.getElementById("web-chat").scrollHeight;
          }
        }, 0);

        if (action.type === "DIRECT_LINE/CONNECT_FULFILLED") {
          console.log("Bot webchat/join:", Date.now());

          
            const portalName = (window.config.isAEM) ? window.config.portalNameAEM : window.config.portalName;

            dispatch({
              type: "WEB_CHAT/SEND_EVENT",
              payload: {
                name: "webchat/join",
                value: {
                  language: window.navigator.language,
                  countrySelectedOnPortal: window.config.countrySelectedOnPortal,
                  accessToken: getCWACookies("cwaSSOToken"),
                  sbg: window.config.sbg,
                  gbe: window.config.gbe,
                  portalName:  portalName,
                  browserTime: new Date(),
                  pageTitle: window.config.pageTitle,
                  portalPageUrl: window.config.portalPageUrl,
                  browserName: window.config.browserName,
                  isOldConversation: getCookie(window.config.businessUnit + '-OldCoversation') ? true : false,
                  encryptedSoldToAccount: window.config.b2bunit,
                  isAEM: window.config.isAEM,
                  isNewSSO: window.config.isNewSSO,
                  isChina: window?.config?.isChina  
                }
              }
             });
          
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "customerInfoCompleted"
        ) {
          if (document.getElementById("spinner-text")) {
            document.getElementById("spinner-text").innerHTML ="Connecting to Honeywell Assist";
          }
        }
        if(
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "typing" &&
          action.payload.activity.value === "marketing"
        ) {
          window.config.showTypingIndicator = true;

          setTimeout(() => {
            window.config.showTypingIndicator = false;
          }, action.payload.activity.delay);
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "defaultWorkflowTaken"
        ) {
          window.config.isDefaultWorkflowClicked = true;
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "initiateWorkflow"
        ) {
          if (!action.payload.activity.value.isReceived && !action.payload.activity.value.isDefaultWorkflow) {
            dispatch({
              type: "WEB_CHAT/SEND_EVENT",
              payload: {
                name: "workflowEventReceived",
                value: {
                  userId: localStorage.getItem("DCAUserId"),
                  workflowId: action.payload.activity.value.workflowId,
                  childWorkflowId: "",
                  pageRuleId: action.payload.activity.value.pageRuleId,
                  pageId: action.payload.activity.value.pageId,
                  priority: action.payload.activity.value.priority
                }
              }
            });
          }

          if ((!window.config.isWorkflowTriggered) ||
            (window.config.isWorkflowTriggered && !window.config.isWorkflowClicked && window.config.isDefaultWorkflow &&
              !action.payload.activity.value.isDefaultWorkflow && action.payload.activity.value.workflowId)
          ) {
            window.config.isDefaultWorkflow = action.payload.activity.value.isDefaultWorkflow;
            window.config.isWorkflowTriggered = true;

            setTimeout(() => {
              context.setEnableScroll(true);
              context.setStartingMessage(action.payload.activity.value.startingMessage);
              context.setWorkflowId(action.payload.activity.value.workflowId);
              context.setPageRuleId(action.payload.activity.value.pageRuleId);
              context.setPageId(action.payload.activity.value.pageId);
              context.setPriority(action.payload.activity.value.priority);
              window.parent.postMessage({ key: 'minimise', launcherIcon: false }, window.config.pageOrigin);
            }, ((action.payload.activity.value.triggerTime - 10) * 1000));
          }
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "openWebform"
        ) {
          if (getCookie(window.config.businessUnit + '-OldCoversation')) {
            if (getCookie(window.config.businessUnit + '-botMaximiseTime')) {
              const date1 = getCookie(window.config.businessUnit + '-botMaximiseTime');
              var difference = new Date().getTime() - date1;
              var minutesDifference = Math.floor(difference / 1000 / 60);
              difference -= minutesDifference * 1000 * 60;
              var secondsDifference = Math.floor(difference / 1000);
              if (secondsDifference > 15) {
                window.open(action.payload.activity.value, "_blank");
              }
            }
          } else {
            window.open(action.payload.activity.value, "_blank");
          }
        }

        if ( //To make webformpopup appear for LAC LOB selection Agent unavailable.
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "webFormPopupVisible"
        ) {
          context.setCaseWebFormArticleModal(action.payload.activity.value);
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "openWebformDynamically"
        ) {
          if (action.payload.activity.value.sametab) {
            window.open(action.payload.activity.value.link, 'Live Chat', 'toolbar=no,scrollbars=yes,resizable=yes,width=433,height=480'); return false;
          } else
            window.open(action.payload.activity.value.link, "_blank");
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "refreshAcknowledge"
        ) {
        //  if(window.config.isAttachment){
        //   const ATTACHMENTS_KEY = window.config.businessUnit+'_dca_persisted_attachments';
        //   sessionStorage.removeItem(ATTACHMENTS_KEY); 
        //   }
          removeDLCookies("sessiontimeout");
          handleRefreshModalPopup();
          setDirectLine(null);
          setStore(null);
          setDirectLineToken();
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "closeAcknowledge"
        ) {
          if (getCookie(window.config.businessUnit + '-adjustResize') && window.config.isAdjustable == true) {
            eraseCookie(window.config.businessUnit + '-adjustResize');
          }
          if (document.getElementById("root").classList.contains("root-max") && !sessionStorage.getItem(window.config.businessUnit + '-SatmatrixSurveyOpen')) {
            handleCloseModalPopup();
            handleCloseBotInTabs();
          }
          else if (!sessionStorage.getItem(window.config.businessUnit + '-SatmatrixSurveyOpen')) {
            window.history.go(0);
          }
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "removeSpinner"
        ) {
          setSpinner(false);
          const elements = document.querySelectorAll("#web-chat ul li");

          if (elements.length > 0) {
            elements.forEach((elem, index) => {
              if (index === window.config.elementsCount) {
                return;
              }
              elem.remove();
            });
          }
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "marketingErrorException"
        ) {
          dispatch({
            type: "WEB_CHAT/SEND_POST_BACK",
            payload: {
              value: {
                processName: "initiateMarketingWorkflow",
                userId: localStorage.getItem("DCAUserId"),
                startingMessage: context.startingMessage,
                workflowId: context.workflowId,
                pageRuleId: context.pageRuleId,
                pageId: context.pageId,
                priority: context.priority,
                exceptionErrorFound: true
              }
            }
          });
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "signin/success"
        ) {
          if (document.getElementById("spinner-text")) {
            document.getElementById("spinner-text").innerHTML =
              "Gathering your information";
          }

          setSpinner(false);
          context.setMinimizeBot(false);

          if (action.payload.activity.value.status) {
            showErrorPage({ isErrorOccured: false, message: "" });

            if (window.config.isWebSocketConnect) {
              let message = JSON.stringify({});

                message = JSON.stringify({ "businessUnit": window.config.businessUnit, "userId": action.payload.activity.value.userid, "conversationId": action.payload.activity.conversation.id });
              

              if (window.config.socket) {
                window.config.socket.send(message);
              } else {
                window.config.socket = new WebSocket(window.config.webSocketUrl);
                window.config.socket.addEventListener("open", function (event) {
                  window.config.socket.send(message);
                  if (event.origin !== window.config.pageOrigin)
                    return;
                });
              }
            }
          } else {
            sessionStorage.removeItem("cwaSSOToken");
            if (getCookie(window.config.businessUnit + '-isPrivacyAccepted') && window.config.isNewPrivacy == true) {
              eraseCookie(window.config.businessUnit + '-isPrivacyAccepted');
            }
            if (getCookie(window.config.businessUnit + '-adjustResize') && window.config.isAdjustable == true) {
              eraseCookie(window.config.businessUnit + '-adjustResize');
            }
            showErrorPage({
              isErrorOccured: true,
              message: {
                text: "Login Failed",
                subText: "Your username and/or password do not match",
                link: {
                  text: "Retry",
                  src: (window.config.isAEM) ? `${window.config.portalUrlAEM}` : `${window.config.portalUrl}`,
                  target: "_parent"
                }
              }
            });
          }
        }

        if (action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "brandBasedPageConfirmation")
        {
            window.config.isBrandBasedPage = action.payload.activity.value.isBrandBasedPage;
            if(!getCookie(window.config.businessUnit + '-OldCoversation')) {
                dispatch({
                    type: "WEB_CHAT/SEND_POST_BACK",
                    payload: {
                        value: {
                            "isBrandBasedPage": action.payload.activity.value.isBrandBasedPage,
                            "brandGreetingMessage":`${GreetUser(window.config.language)}! `
                        }
                    }
                });

            context.setShowHeaderFooter(true);
            context.setShowSendBox(true);
            context.setEnableScroll(true);
            context.setHideStickyMenu(false);
            context.setMoreOptionsClick(false);
            setCookie(window.config.businessUnit + '-Conversation', true);
          }
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "getCredsDetails"
        ) {
          window.config.documentDownloadAPI=action.payload.activity.value?.documentDownloadAPI;
          window.config.searchServiceApi=action.payload.activity.value?.searchServiceApi;
        }
        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "EnableAttachmentIcon"
        ) {
           window.config.isPartiallyAuthenticated = action.payload.activity.value;
        }
        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "feedback"
        ) {
          if (action.payload.activity.value.checkShowOrHideSurvey) {
            context.setShowSurvey(action.payload.activity.value.sendSurvey);
            surveyPageShow.current = action.payload.activity.value.sendSurvey;

            if (surveyPageShow.current) {
              handleSurveyCardChange();
              setHeaderIconsDisplay(false);
              context.setShowHeaderFooter(false);
              context.setEnableScroll(false);
            } else {
              showModal(true);
              context.setModalProps({ refresh: false, close: true, quitAgentQueue: false, busyNotification: false });
            }
          } else {
            handleSurveyCardChange();
            setHeaderIconsDisplay(false);
            context.setShowHeaderFooter(false);
            context.setEnableScroll(false);
          }
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "feedbackGoBackButtonAck"
        ) {
          showSurvey(false);
          context.setOptionSelected(true);
          context.setShowHeaderFooter(true);
          context.setEnableScroll(true);
          setHeaderIconsDisplay(true);
        }
        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "showDisclaimerLimit"
        ) {
         window.config.isDisclaimer=true;
         window.config.charLimit=true;
      }
         if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "progressIndicatorStart"
        ) {
          window.config.progressIndication=true;
          window.config.progressIndicationName=action.payload.activity.value;
        }
         if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "progressIndicatorStop"
        ) {
          window.config.progressIndication=false;
          window.config.progressIndicationName=action.payload.activity.value;
        }
         if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "hideDisclaimerLimit"
        ) {
         window.config.isDisclaimer=false;
         window.config.charLimit=false;
        }
        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "feedbackCancelButtonAck"
        ) {
          showModal(false);
          context.setModalProps({ refresh: false, close: false, quitAgentQueue: false, busyNotification: false });
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "exitQueueButtonAck"
        ) {
          setShowTimerBox(false);
          context.setLiveAgent(false);
          context.setShowSendBox(true);
          context.setDisableSendBox(true);
          context.setEnableScroll(true);
          context.setHideStickyMenu(false);
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "updatedFeedback"
        ) {
            handleSurveyCardChange();
            setHeaderIconsDisplay(false);
            context.setShowHeaderFooter(false);
            context.setEnableScroll(false);
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "closeBot"
        ) {
          context.setMenuOpen(false);
          context.setMinimizeBot(false);

          sessionStorage.setItem('notification', false);
          sessionStorage.removeItem("chatbotActive");
          document.getElementById("root").removeAttribute("style");
          document.getElementById("root").classList.remove("root-max");
          document.getElementById("main").classList.remove("main-max");
          document.getElementById("main").classList.add("main-min");

          if (!JSON.parse(sessionStorage.getItem('notification'))) {
            window.parent.postMessage({ key: 'minimise', launcherIcon: false }, window.config.pageOrigin);
          }

          setMaximizeflag(isMaximised);

         
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "refresh"
        ) {
          showModal(true);
          context.setModalProps({ refresh: true, close: false, quitAgentQueue: false, busyNotification: false });
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "userLanguage"
        ) {
          setUserLanguage(action.payload.activity.value);
          window.config.language = action.payload.activity.value;
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "requestcallback"
        ) {
          window.open(action.payload.activity.value, "_blank");
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "agentsNotAvailable"
        ) {
          context.setShowSendBox(true);
          setShowTimerBox(false);
          setAgentInitiated(false);
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "agentdisconnected"
        ) {
          // if(window.config.isAttachment){
          // const ATTACHMENTS_KEY = window.config.businessUnit+'_dca_persisted_attachments';
          // sessionStorage.removeItem(ATTACHMENTS_KEY); 
          // }
          // sessionStorage.removeItem("AgentSessionID");
          context.setShowSendBox(false);
          setAgentInitiated(false);
          context.setLiveAgent(false);
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "agentInitiated"
        ) {
          if (!window.config.isNewUI) {
            context.setShowSendBox(false);
            context.setHideStickyMenu(true);
            context.setDisableSendBox(false);
          }
          setAgentInitiated(true);
          setShowTimerBox(true);

          var callBackUrl = "";
          switch (window.config.sbg) {
            case "AERO":
              callBackUrl = action.payload.activity.value.supportCategory === "Customer Support" ? window.config.customerSupportUrl : window.config.technicalSupportUrl;
              break;
            default:
              callBackUrl = window.config.customerSupportUrl;
          }

          setCallbackFormUrl(callBackUrl);

        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "webformPopup"
        ) {
          context.setWebformContent(action.payload.activity.value.content);
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "agentDiffSupportCategory"
        ) {

          var callBackUrl = "";
          switch (window.config.sbg) {
            case "AERO":
              callBackUrl = action.payload.activity.value.supportCategory === "Customer Support" ? window.config.customerSupportUrl : window.config.technicalSupportUrl;
              break;
            default:
              callBackUrl = "";
          }

          setCallbackFormUrl(callBackUrl);

        }

        // if (
        //   action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
        //   action.payload.activity.type === "event" &&
        //   action.payload.activity.name === "showAgentTimerBox"
        // ) {
        //   context.setShowSendBox(false);
        //   context.setHideStickyMenu(true);
        //   context.setDisableSendBox(false);
        // }

         if (
           action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
           action.payload.activity.type === "event" &&
           action.payload.activity.name === "disableSendBox"
         ) {
           if(!context.isLiveAgent){
             context.setDisableSendBox(true);
           }
         }
         
         if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "enableTextBox"
        ) {
          context.setEnableSendBoxAERO(true);
        }
        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "modalSubmitCancelled"
        ) {
          context.setCaseWebFormArticleModal(false);
        }
        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "enableSendBox"
        ) {
          context.setDisableSendBox(false);
          setCookie(window.config.businessUnit + '-EnableSendBox', true);
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "enableSendBoxEventAcknowledged"
        ) {
          context.setDisableSendBox(true);
          setCookie(window.config.businessUnit + '-EnableSendBox', false);
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "enableRestrictionInTextbox"
        ) {
          context.setRestrictTextBox(true);
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "disableRestrictionInTextbox"
        ) {
          context.setRestrictTextBox(false);
        }
        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "viewOriginalLineItemsButtonId"
        ) {
          const viewOriginalLineItemsButtonId = action.payload.activity.value.viewOriginalLineItemsButtonId;
        }
        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "disableViewLineItemButton"
        ) {
          const viewLineItemsButtonId = action.payload.activity.value.viewLineItemsButtonId;
          if (document.getElementById(viewLineItemsButtonId)) {
            document.getElementById(viewLineItemsButtonId).disabled = true;
          }
        }
        //  if (
        //   action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
        //   action.payload.activity.type === "event" &&
        //   action.payload.activity.name === "disableSuggestedInput"
        // ) {
        //    window.config.disableSuggest=true;
        // }
        //   if (
        //   action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
        //   action.payload.activity.type === "event" &&
        //   action.payload.activity.name === "enableSuggestedInput"
        // ) {
        //  window.config.disableSuggest=false;
        // }
        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "disableConfirmLineItemButton"
        ) {
          let submitObject = {
            id: action.payload.activity.value.confirmLineItemsButtonId,
            ...action.payload.activity.value.geographyValue
          }
          let checkHistory = getCookie(window.config.businessUnit + '-CheckOrderLob');
          if (checkHistory) {
            checkHistory = JSON.parse(checkHistory);
            if (Array.isArray(checkHistory)) {
              if (!checkHistory.map(i => i.id).includes(submitObject.id)) {
                setCookie(window.config.businessUnit + '-CheckOrderLob', JSON.stringify([...checkHistory, submitObject]))
              }
            }
          }
          else {
            setCookie(window.config.businessUnit + '-CheckOrderLob', JSON.stringify([submitObject]))
          }
          const confirmLineItemsButtonId = action.payload.activity.value.confirmLineItemsButtonId;
          if (document.getElementById(confirmLineItemsButtonId)) {
            document.getElementById(confirmLineItemsButtonId).disabled = true;
          }
        }
        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "disableViewOriginalLineItemButton"
        ) {
          const viewOriginalLineItemsButtonId = action.payload.activity.value;
          setTimeout(() => {
            if (document.getElementById(viewOriginalLineItemsButtonId)) {
              document.getElementById(viewOriginalLineItemsButtonId).style.display = "none";
            }
          }, 500);
        }
        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "disableQnaSuggestionList"
        ) {
          const qnaSuggestionList = document.getElementsByClassName(action.payload.activity.value.qnaSuggestionListClassName);

          if (qnaSuggestionList.length > 0) {
            for (let i = 0; i < qnaSuggestionList.length; i++) {
              qnaSuggestionList[i].disabled = true;
            }
          }
        }
        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          (action.payload.activity.name === "agentEWT")
        ) {
          if (!window.config.hasDispatchedAgentEWT) {
            window.config.hasDispatchedAgentEWT = true;
            dispatch({
              type: "WEB_CHAT/SEND_EVENT",
              payload: {
                name: "EWTLogging",
                value: action.payload.activity.value
              }
            });
          }
          window.config.estimatedWaitTime = formatWaitTime(action.payload.activity.value,liveAgentStaticLabels[window.config.language].agentHours,liveAgentStaticLabels[window.config.language].agentHour,liveAgentStaticLabels[window.config.language].agentMinutes,liveAgentStaticLabels[window.config.language].agentMinute);
        }
        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          (action.payload.activity.name === "agentjoined" || action.payload.activity.name === "agenttransfered")
        ) {
          context.setSessionId(action.payload.activity.conversation.id)
          context.setLiveAgentName(action.payload.activity.value.agentname);
          context.setShowSendBox(true);
          context.setHideStickyMenu(true);
          context.setDisableSendBox(false);
          setShowTimerBox(false);
          context.setLiveAgent(true);
          showModal(false);
        }
        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          (action.payload.activity.name === "languageUserSelected")
        ) {
          context.setLiveAgentDropdownLanguagePreferred(action.payload.activity.value.liveAgentPreferredLanguage);
        }
        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          (action.payload.activity.name === "agentJoinedTransfer")
        ) {
          context.setTranscriptTranslationRequired(action.payload.activity.value.transcriptTranslationRequired);
        }
        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "SendTriggerSurvey"
        ) {
          context.setShowSurvey(true);
          surveyPageShow.current = true;
          dispatch({
            type: "WEB_CHAT/SEND_EVENT",
            payload: {
              name: "GetSurveyLink"
            }
          });
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "hideStickyMenu"
        ) {
          context.setHideStickyMenu(true);
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "displayStickyMenu"
        ) {
          context.setHideStickyMenu(false);
        }

        if (action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "GetGreeting"
        ) {
          const currentTime = new Date();
          let greetingMessage = "";

          if (currentTime.getHours() < 12) {
            greetingMessage = "Good Morning";
          } else if (currentTime.getHours() < 17) {
            greetingMessage = "Good Afternoon";
          } else {
            greetingMessage = "Good Evening";
          }

          dispatch({
            type: "WEB_CHAT/SEND_EVENT",
            payload: {
              name: "SendGreeting",
              value: greetingMessage
            }
          });
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "agentqueuecount"
        ) {
          if (!window.config.isNewUI) {
            context.setShowSendBox(false);
          }
          setShowTimerBox(true);
          context.setUsersCount(action.payload.activity.value);
        }

        // if (action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
        //   action.payload.activity.type === "event" &&
        //   action.payload.activity.name === "agentcallbackform") {
        //     // if(isOpenModal){
        //     //    showModal(true);
        //     // }
        //     showModal(true);
        //     context.setModalProps({ refresh: false, close: false, quitAgentQueue: false, busyNotification: true });
        //   if (action.payload.activity.value === "GTO") {
        //     setCallbackFormUrl("https://aerospace.stage.honeywell.com/en/secure/contact-us/forms/technical-issue/commercial-new");
        //   }
        //   if (action.payload.activity.value === "GCE") {
        //     setCallbackFormUrl("https://aerospace.stage.honeywell.com/en/contact-us");
        //   }
        // }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "SatmetrixSurveyLink"
        ) {

          if (satmatrixSurvey)
            setSatmatrixSurveyIFrame(true);
          setSurveyLink(action.payload.activity.value);

          // window.open(
          //   action.payload.activity.value,
          //   "targetWindow",
          //   "toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=600,height=600"
          // );
        }

        if (
          action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          isRejectedActivity
        ) {
          isRejectedActivity = false;
          if (document.getElementsByClassName("sendRetry").length != 0) {
            Array.prototype.forEach.call(
              document.getElementsByClassName("sendRetry"),
              function (element) {
                element.style.visibility = "hidden";
              }
            );
            Array.prototype.forEach.call(
              document.getElementsByClassName("sendRetry"),
              function (element) {
                element.style.display = "none";
              }
            );
          }
        }

        if (
          action.type === "DIRECT_LINE/POST_ACTIVITY_REJECTED" &&
          action.error
        ) {
          if (action.payload.message.indexOf("cancelled timeout") !== -1) {
            showErrorPage({
              isErrorOccured: true,
              message: {
                text: "Network Error",
                subText: "The network connection is lost",
                link: {
                  text: "Please Contact Customer Support",
                  src: window.config.supportUrl,
                  target: "_blank"
                }
              }
            });
            setSpinner(false);
          } else {
            isRejectedActivity = true;


            //  dispatch({
            //     type: 'WEB_CHAT/SEND_POST_BACK',
            //    payload:{value:sessionStorage.getItem("UserLastMessage")}

            //   });
            if (document.getElementsByClassName("sendRetry").length != 0) {
              document.getElementsByClassName("sendRetry")[
                document.getElementsByClassName("sendRetry").length - 1
              ].style.visibility = "visible";
              document.getElementsByClassName("sendRetry")[
                document.getElementsByClassName("sendRetry").length - 1
              ].style.display = "block";
            }
          }
        }

        if (action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
          action.payload.activity.type === "event" &&
          action.payload.activity.name === "accountChangedPopup"
        ) {
          showModal(true);
          context.setIsAccountChanged(true)
          context.setModalProps({ refresh: false, close: false, quitAgentQueue: false, busyNotification: true });
        }
        try {
          let result = next(action);
          return result;
        } catch (err) {
        }
      }),
      [
        showSpinner,
        accessToken,
        handleSpinnerChange,
        setSpinner,
        handleModalChange,
        setSurveyLink,
        setSatmatrixSurveyIFrame
      ]
    );
  }

  return (
    isDisplay && (
      <TelemetryProvider
        style={{ height: "100%" }}
        instrumentationKey={window.config["5367726563746c696e650e07c17c33k"].split("&=")[1]}
        after={() => {
          setAppInsights(getAppInsights());
        }}
      >
        <React.Fragment>
          <div className="main" id="main">
            <Header
              isMaximised={isMaximised}
              ref={headerRef}
              store={store}
              directLine={directLine}
              handleRefreshModalPopup={handleRefreshModalPopup}
              handleCloseModalPopup={handleCloseModalPopup}
              handleMaximizeChange={handleMaximizeChange}
              handleModalChange={handleModalChange}
              handleSurveyCardChange={handleSurveyCardChange}
              isOpenModal={isOpenModal}
              isLiveAgent={isLiveAgent}
              userLanguage={userLanguage}
              headerIconsDisplay={headerIconsDisplay}
              surveyLink={surveyLink}
              isSurveyOpen={isSurveyOpen}
            />
            {accessToken && !errorOccured.isErrorOccured ? (
              // !satmatrixSurveyIFrame ? 
              <MainWebChat
                showSpinner={showSpinner}
                isMaximised={isMaximised}
                isSurveyOpen={isSurveyOpen}
                userLanguage={userLanguage}
                handleMaximizeChange={handleMaximizeChange}
                handleCloseModalPopup={handleCloseModalPopup}
                handleSurveyCardChange={handleSurveyCardChange}
                directLine={directLine}
                store={store}
                isLiveAgent={isLiveAgent}
                handleModalChange={handleModalChange}
                styleSet={styleSet({})}
                appInsights={appInsights}
                showTimerBox={showTimerBox}
                setShowTimerBox={setShowTimerBox}
                handleSpinnerChange={handleSpinnerChange}
                showSurvey={showSurvey}
                setHeaderIconsDisplay={setHeaderIconsDisplay}
                surveyLink={surveyLink}
                setSatmatrixSurvey={setSatmatrixSurvey}
                setSatmatrixSurveyIFrame={setSatmatrixSurveyIFrame}
                satmatrixSurveyIFrame={satmatrixSurveyIFrame}
                isAgentInitiated={isAgentInitiated}
                setLiveAgent={setLiveAgent}
                setDirectLineTokenCall={setDirectLineTokenCall}
                headerRef={headerRef}
              />
            ) : (
               !errorOccured.isErrorOccured && (
                <ErrorHandler
                  isMaximised={isMaximised}
                  message={{
                    text: "Access Denied",
                    subText: "You are not authorized to use this application.",
                    link: {
                      text: "Please Contact Customer Support",
                      src: window.config.supportUrl,
                      target: "_blank"
                    }
                  }}
                />
              )
            )}
            {errorOccured.isErrorOccured ? (
              <ErrorHandler
                isMaximised={isMaximised}
                message={errorOccured.message}
              />
            ) : (
              ""
            )}
            <Footer isMaximised={isMaximised} />
          </div>
        </React.Fragment>
      </TelemetryProvider>
    )
  );
};